import React from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const filled = Math.round((TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100);
  return <div className="w-full rounded-2xl border border-danger/20 bg-danger-soft p-4 text-left" data-id="element-57" data-mp="2l2tpqeg4bdmj">
      <div className="flex items-center justify-between gap-3" data-id="element-58" data-mp="2q1wkn62dw3gs">
        <p className="flex items-center gap-2 text-sm font-extrabold text-danger sm:text-base" data-id="element-59" data-mp="2b5p024n2d00z">
          <FlameIcon className="h-5 w-5 shrink-0 animate-soft-pulse" aria-hidden="true" data-id="element-60" data-mp="2g6w884t4c186" />
          Only {SPOTS_LEFT} spots left at the promotional price
        </p>
        <span className="shrink-0 text-sm font-black text-danger" data-id="element-61" data-mp="274vehhx3fxb9">{filled}%</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-62" data-mp="ep6zvhdnitt">
        <motion.div className="h-full rounded-full bg-danger" initial={{
        width: "0%"
      }} whileInView={{
        width: `${filled}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-63" data-mp="33lk20gphxxd1" />
      </div>
      <p className="mt-2 text-xs font-medium text-ink-muted" data-id="element-64" data-mp="38emok4vuw6jq">
        {TOTAL_SPOTS - SPOTS_LEFT} of {TOTAL_SPOTS} promotional spots already claimed. When they run out, the $27 price ends.
      </p>
    </div>;
}